import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import useApiRequest from "../../utils/hooks/useApiRequest";
import { GET_TIME_FROM_BIRTHDAY } from "../../app/api/apiRoutes";
import useFacility from "../../utils/hooks/useFacility";
import { Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import EAButton from "../../app/components/shared/Buttons/EAButton";
import { addHours, isAfter, isToday, parse } from "date-fns";

interface IProps {
  value: string;
  label: string;
  name: string;
  setTime: (value: string) => void;
  dateFrom: string;
  dateTo: string;
  assortIds: string;
}

const InputTimeForBirthDay: React.FC<IProps> = ({
  value,
  label,
  name,
  setTime,
  dateTo,
  dateFrom,
  assortIds,
}: IProps) => {
  const [open, setOpen] = useState(false);
  const [timeList, setTimeList] = useState<string[]>([]);
  const { get } = useApiRequest();
  const facility = useFacility();
  const { t } = useTranslation();

  const getTime = async () => {
    const { result, isError } = await get(GET_TIME_FROM_BIRTHDAY(facility, dateFrom, dateTo, assortIds));
    if (!isError) {
      const searchDate = result.find((item: any) => item.date === dateFrom);
      if (assortIds === "0,431") {
        // TUTAJ W IF DODAJEMY NA SZTYWNO ID ASORTYMENTU W KTÓRYM FILTRUJE NAM PO GODZINACH
        setTimeList(filterHours(searchDate));
      } else if (assortIds === "0,480") {
        setTimeList(filterHours(searchDate, "15:00"));
      } else {
        setTimeList(searchDate ? searchDate.hours : []);
      }
    }
  };

  const filterHours = (searchDate: any, startHour: string = "00:00"): string[] => {
    if (!searchDate) return [];

    const currentTime = new Date();
    let targetTime = new Date(currentTime.setMinutes(0, 0, 0));

    if (isToday(new Date(searchDate.date))) {
      targetTime = addHours(targetTime, 3); // Ustaw docelowy czas na 3 godziny później, tylko jeśli to dzisiaj
    } else if (startHour) {
      targetTime = parse(startHour, "HH:mm", new Date()); // Ustaw na godzinę startową np. 15:00
    }

    return searchDate.hours.filter((hourString: string) => {
      const hourDate = parse(hourString, "HH:mm", new Date());
      return isAfter(hourDate, targetTime) || hourDate.getTime() === targetTime.getTime(); // Uwzględnij godziny równe targetTime
    });
  };

  const onSelectTime = (value: string) => {
    setTime(value);
    setOpen(false);
  };

  useEffect(() => {
    if (open) {
      getTime();
    }
    //eslint-disable-next-line
  }, [open]);

  return (
    <>
      <div className={"form-input-date"}>
        <label htmlFor={name}>{label}</label>
        <EAButton title={value ? value : t("wybierz_godzine")} onClick={() => setOpen(true)} />
      </div>

      {open && (
        <Modal
          isOpen={open}
          onRequestClose={() => setOpen(false)}
          contentLabel="modal"
          className="modal-calendar"
          style={{ content: { minWidth: "40vmin", maxWidth: "60vmin" } }}
        >
          <>
            <h3>{t("wybierz_godzine_wejscia")}:</h3>
            <div className="line-horizontal"></div>
            <Grid className={"birthday-hours"} container spacing={2}>
              {timeList.map((item, index) => (
                <Grid key={index} item xs={2}>
                  <EAButton title={item} onClick={() => onSelectTime(item)} variant="outlined" />
                </Grid>
              ))}
            </Grid>
          </>
        </Modal>
      )}
    </>
  );
};

export default InputTimeForBirthDay;
